import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { dateService, FORMATS } from '@/global/services/date'

const TAB_KEY = 'basicInfo'
export default {
  name: 'basicInfo',

  computed: {
    basicInfoCreateConfig () {
      return {
        title: this.$t('base/profile.basic_info'),
        key: TAB_KEY,
        apiConfig: {
          post: {
            module: 'administration',
            route: 'expenses',
            method: 'post'
          }
        },
        modifyDataBeforeSend: (event) => this.onModifyDataBeforeSend(event),
        afterSave: () => this.backToMainTable(),
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('administration/expense.new_expense_details'),
            showBackButton: {
              onGoBack: () => this.backToMainTable(false)
            },
            onCancelTabSave: () => this.backToMainTable(false)
          },
          {
            component: this.columnsContentComponent,
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 4,
                fields: [
                  {
                    key: 'date',
                    label: this.$t('administration/expense.date'),
                    type: 'datetime-picker',
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.datetimeShort,
                    placeholder: FORMATS.datetimeShort,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'type_id',
                    label: this.$t('administration/expense_type.type'),
                    placeholder: this.$t('administration/expense.choose_expense_type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'administration',
                      route: 'expense-types/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'vehicle_id',
                    label: this.$t('administration/expense.vehicle'),
                    placeholder: this.$t('administration/expense.choose_vehicle'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'vehicles/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'person_id',
                    label: this.$t('people/person.driver'),
                    placeholder: this.$t('administration/expense.choose_driver'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'people',
                      route: 'people/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'partner_id',
                    label: 'Partner',
                    placeholder: this.$t('administration/expense.choose_partner'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'administration',
                      route: 'partners/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'item',
                    label: this.$t('administration/expense.item'),
                    placeholder: this.$t('administration/expense.enter_article'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'quantity',
                    label: this.$t('administration/expense.quantity'),
                    field_type: 'number',
                    placeholder: this.$t('administration/expense.enter_quantity'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'bill_number',
                    label: this.$t('administration/expense.bill_number'),
                    placeholder: this.$t('administration/expense.enter_bill_number'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'net_amount',
                    label: this.$t('administration/expense.net_amount'),
                    placeholder: this.$t('administration/expense.enter_net_amount'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'gross_amount',
                    label: this.$t('administration/expense.gross_amount'),
                    placeholder: this.$t('administration/expense.enter_gross_amount'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'currency_id',
                    label: this.$t('administration.currency'),
                    placeholder: this.$t('administration/expense.choose_currency'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'administration',
                      route: 'currencies/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    onModifyDataBeforeSend (event) {
      const { copiedData } = event || {}
      if (copiedData) {
        copiedData.date = copiedData?.date ? dateService.formatCustom(copiedData.date, FORMATS.datetimeShort, FORMATS.isoDatetime) : null
        copiedData.net_amount = copiedData?.net_amount ? copiedData.net_amount.replace(',', '.') : null
        copiedData.gross_amount = copiedData?.gross_amount ? copiedData.gross_amount.replace(',', '.') : null
        copiedData.quantity = copiedData?.quantity ? copiedData.quantity.replace(',', '.') : null
      }
      return copiedData
    },

    backToMainTable (refreshData = true) {
      // exit from create mode to main table
      this.createMode = false
      if (refreshData) {
        const { fetchData } = registeredTableHandlers?.expenses || {}
        fetchData?.()
      }
    }
  }
}
